import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import TrustBand from './components/TrustBand';
import AboutSection from './components/AboutSection';
import TreatmentsSection from './components/TreatmentsSection';
import JourneySection from './components/JourneySection';
import AISearchSection from './components/AISearchSection';
import VoiceSearchSection from './components/VoiceSearchSection';
import TechnologySection from './components/TechnologySection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div style={{ fontFamily: 'DM Sans, sans-serif' }}>
      <Navbar />
      <main>
        <HeroSection />
        <TrustBand />
        <AboutSection />
        <TreatmentsSection />
        <JourneySection />
        <AISearchSection />
        <VoiceSearchSection />
        <TechnologySection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
